import * as c from './constants'

const initialState = {
  initialized: false,
  isFetching: false,
  isLive: false,
}

export default function virtualAgentReducer(state = initialState, action) {
  switch (action.type) {
    case c.NEW_USER_MSG:
    case c.DROPDOWN_ITEM_CLICK:
    case c.NEW_USER_QUICK_REPLY: {
      return { ...state, isFetching: true }
    }
    case c.FETCH_BOT_RESPONSE_SUCCESS: {
      return { ...state, isFetching: false }
    }
    case c.CLOSE_CONVERSATION: {
      return { ...state, initialized: false }
    }
    case c.BOT_INITIALIZED: {
      return { ...state, initialized: true }
    }

    case c.START_POLLING: {
      return { ...state, isLive: true }
    }

    case c.STOP_POLLING: {
      return { ...state, isLive: false }
    }

    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/App/reducer.js